// extracted by mini-css-extract-plugin
module.exports = {"disclaimerNotice":"styles_disclaimerNotice__21hKZ","is-dark-mode":"styles_is-dark-mode__1Mjfy"};